import { Pipe, PipeTransform } from '@angular/core';
import { InstallationObservationPluginService } from './observationsandrecommandations-plugin.service';

@Pipe({
    name: 'responsibles',
    standalone: false
})
export class ObservationResponsiblesPipe implements PipeTransform {
  public responsibles: any;

  constructor(private service: InstallationObservationPluginService) {
    this.responsibles = this.service.getResponsibles();
  }

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.responsibles);
  }
}
